import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Globals} from '../../../global/global.model';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';


@Injectable()
export class FotoRecepcionistasServices {

	constructor(private http: HttpClient) { }

	saveFotoRecepcionista(data:any){
		return this.http.post(Globals.BASE_URL_API_REST+'fotorecepcionistas.json',data);
	}

	deleteFotoRecepcionista(id:number){
		return this.http.delete(Globals.BASE_URL_API_REST+'fotorecepcionistas/'+id+'.json');
	}


}